module.exports = __webpack_public_path__ + "img/uk.2243c41f.svg";